import React from 'react';
import './index.scss';

const Spinner = () => <div className="loader"></div>;

export default Spinner;
